export const PageMode = {
    Live: 0,
    Design: 1
}